'use client';

import { useCallback, useRef } from 'react';
import { useMetrica } from 'next-yandex-metrica';
import {
	trackCandidateEvent,
	type CandidateEvent,
	type CandidateEventContext,
} from '../lib/presentation';

export function useCandidateAnalytics(interviewId: string, entryPoint: string) {
	const { reachGoal } = useMetrica();
	const goal = useRef(reachGoal);
	goal.current = reachGoal;
	return useCallback(
		(event: CandidateEvent, context: CandidateEventContext = {}) => {
			trackCandidateEvent(goal.current, event, {
				interviewId,
				entryPoint,
				...context,
			});
		},
		[interviewId, entryPoint],
	);
}
